// third-party
import React from "react";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import EmailIcon from "@mui/icons-material/Email";
import { Shield } from "lucide-react";
import { Dashboard } from '@mui/icons-material';

// assets
import tagsIcon from "../../assets/icons/layers-logo.svg";

// icons
const icons = {
  dashboard: () => <Dashboard sx={{ fontSize: 20, color: "inherit" }} />,
  tags: () => <img src={tagsIcon} alt="expert icon" />,
  gamification: () => (
    <CardGiftcardIcon sx={{ fontSize: 20, color: "inherit" }} />
  ),
  roleGenerate: () => <Shield size={18} color="white" />,
  newsletters: () => <EmailIcon sx={{ fontSize: 20, color: "inherit" }} />,
  // sources: () => <img width={18} src={sourcesIcon} alt="sources icon" style={{ filter: 'brightness(0) invert(1)' }} />,
};

// ==============================|| MENU ITEMS - PAGES ||============================== //

const managements = {
  id: "group-managements",
  title: "managing : ",
  type: "group",
  children: [
    {
      id: "Dashboard",
      title: "Dashboard",
      type: "item",
      url: "admin/dashboard",
      icon: icons.dashboard,
    },
    {
      id: "Tags",
      title: "Tags",
      type: "item",
      url: "admin/tags",
      icon: icons.tags,
    },
    {
      id: "Gamification",
      title: "Gamification",
      type: "item",
      url: "admin/gamification",
      icon: icons.gamification,
    },
    {
      id: "Newsletters",
      title: "Newsletters",
      type: "item",
      url: "admin/newsletters",
      icon: icons.newsletters,
    },
    {
      id: "RoleGenerate",
      title: "Rôles sub-admins",
      type: "item",
      url: "admin/role-generate",
      icon: icons.roleGenerate,
    },
    // {
    //   id: 'Sources',
    //   title: 'Sources',
    //   type: 'item',
    //   url: 'admin/list-sources',
    //   icon: icons.sources,
    // },
  ],
};

export default managements;
